/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from "prop-types";
import "./subscription-helpers.m.css";
import { Link } from "@quintype/components";
import { TEXT } from "../constants";
import {
  BIRUBAL_BIRUBALA_NL_SENA,
  BIRUBAL_GIFTING_NL_CLIP_BOX_SUBSCRIPTION,
  BIRUBALA_STUDENT,
  COMPRESS_PARAMS_EXTRA_SMALL,
  HANDS_HOLDING_NL_CLIP,
  STUDENT_SUBSCRIPTION,
} from "../../../../image-constants";

export const SubscriptionHelper = (props) => {
  return (
    <div styleName="wrapper" className="full-width">
      <div style={{ maxWidth: "1200px", margin: "auto" }}>
        <div styleName="helper-boxes">
          {props.gift ? (
            <div styleName="box">
              <img
                styleName="image"
                src={`${HANDS_HOLDING_NL_CLIP}${COMPRESS_PARAMS_EXTRA_SMALL}`}
                alt="sub"
              />
              <div styleName="content">
                <h3 styleName="heading">{TEXT.subscriptionTitle}</h3>
                <p styleName="text">{TEXT.subscriptionDescription}</p>
              </div>
              <div styleName="button-wrapper">
                <Link href="/subscription" styleName="button">
                  Subscribe Now
                </Link>
              </div>
            </div>
          ) : (
            <div styleName="box">
              <img
                styleName="image"
                src={`${BIRUBAL_GIFTING_NL_CLIP_BOX_SUBSCRIPTION}${COMPRESS_PARAMS_EXTRA_SMALL}`}
                alt="gift sub"
              />
              <div styleName="content">
                <h3 styleName="heading">{TEXT.giftTitle}</h3>
                <p styleName="text">{TEXT.giftDescription}</p>
              </div>
              <div styleName="button-wrapper">
                <Link href="/gift" styleName="button">
                  Gift Subscription
                </Link>
              </div>
            </div>
          )}
          <div styleName="box">
            <img
              styleName="image"
              src={`${BIRUBALA_STUDENT}${COMPRESS_PARAMS_EXTRA_SMALL}`}
              alt="newslaundry logo"
            />
            <div styleName="content">
              <h3 styleName="heading">{TEXT.studentTitle}</h3>
              <p styleName="text">{TEXT.studentDescription}</p>
            </div>
            <div styleName="button-wrapper">
              <Link href="/student-subscription" styleName="button">
                Learn More
              </Link>
            </div>
          </div>
          <div styleName="box">
            <img
              styleName="image"
              src={`${BIRUBAL_BIRUBALA_NL_SENA}${COMPRESS_PARAMS_EXTRA_SMALL}`}
              alt="newslaundry logo"
            />
            <div styleName="content">
              <h3 styleName="heading">{TEXT.senaTitle}</h3>
              <p styleName="text">{TEXT.senaDescriptiion}</p>
            </div>
            <div styleName="button-wrapper">
              <Link href="/sena" styleName="button">
                Join NL Sena
              </Link>
            </div>
          </div>
          <div styleName="box">
            <img
              styleName="image"
              src={`${STUDENT_SUBSCRIPTION}${COMPRESS_PARAMS_EXTRA_SMALL}`}
              alt="newslaundry group subscription"
            />
            <div styleName="content">
              <h3 styleName="heading">{TEXT.groupTitle}</h3>
              <p styleName="text">{TEXT.groupDescription}</p>
            </div>
            <div styleName="button-wrapper">
              <Link href="/group-subscription" styleName="button">
                Know More
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SubscriptionHelper.propTypes = {
  config: PropTypes.object,
};
